/*
 * Rennsieger — Door Light product page.
 *
 * Variant dropdown picker (long logo/model lists), a 1-Set / 2-Sets bundle selector
 * (2 Sets = a second pair with 30% off, applied by the automatic discount at checkout —
 * here we just set the quantity and show the 2-for price + struck compare-at), the
 * gallery, and a click-to-inspect zoom lightbox. No dependencies; no-ops when absent.
 */
(function () {
  'use strict';

  var root = document.querySelector('.rsg-dl');
  if (!root) return;

  // Matches money_without_trailing_zeros: whole -> "$85", part -> "$144.50".
  function money(cents) {
    var v = cents / 100;
    var s = (cents % 100 === 0) ? v.toFixed(0) : v.toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---------------- variant picker + bundle pricing ---------------- */
  function initBuy() {
    var form = root.querySelector('#rsg-dl-form');
    var vEl = root.querySelector('[data-rsg-hp-variants]');
    var oEl = root.querySelector('[data-rsg-hp-options]');
    if (!form || !vEl || !oEl) return;

    var variants = JSON.parse(vEl.textContent);
    var optionNames = JSON.parse(oEl.textContent);
    var selects = Array.prototype.slice.call(form.querySelectorAll('[data-rsg-dl-opt]'));

    var idInput = form.querySelector('[data-rsg-hp-id]');
    var qtyInput = form.querySelector('[data-rsg-qty-input]');
    var priceEls = root.querySelectorAll('[data-rsg-hp-price]');
    var wasEl = root.querySelector('[data-rsg-hp-was]');
    var atc = root.querySelector('[data-rsg-hp-atc]');
    var atcLabel = root.querySelector('[data-rsg-hp-atc-label]');

    var setBtns = Array.prototype.slice.call(root.querySelectorAll('[data-rsg-dlset-opt]'));
    var p1El = root.querySelector('[data-rsg-dlset-p1]');
    var p2El = root.querySelector('[data-rsg-dlset-p2]');
    var c2El = root.querySelector('[data-rsg-dlset-c2]');

    var sets = 1;

    function selected() {
      return optionNames.map(function (_, i) {
        var s = form.querySelector('[data-opt-index="' + i + '"]');
        return s ? s.value : (variants[0] ? variants[0]['option' + (i + 1)] : '');
      });
    }
    function findVariant(vals) {
      for (var k = 0; k < variants.length; k++) {
        var m = true;
        for (var i = 0; i < vals.length; i++) {
          if (variants[k]['option' + (i + 1)] !== vals[i]) { m = false; break; }
        }
        if (m) return variants[k];
      }
      return null;
    }

    function render() {
      var cur = findVariant(selected());
      if (!cur) {
        if (atc) atc.disabled = true;
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = cur.id;
      if (qtyInput) qtyInput.value = sets;

      var unit = cur.price;
      // the pre-sale per-set price (compare-at) if the set is on sale, else its price
      var setWas = (cur.compare_at_price && cur.compare_at_price > unit) ? cur.compare_at_price : unit;
      var twoFor = Math.round(unit * 1.7);   // both pairs at the sale price, 2nd pair 30% off
      var twoWas = setWas * 2;               // two sets at the pre-sale price (e.g. $170 x2 = $340)

      // fill the tile prices
      if (p1El) p1El.textContent = money(unit);
      if (p2El) p2El.textContent = money(twoFor);
      if (c2El) c2El.textContent = money(twoWas);

      // main price line = the total for the chosen sets
      var total = sets === 2 ? twoFor : unit;
      priceEls.forEach(function (el) { el.textContent = money(total); });
      if (wasEl) {
        if (sets === 2) {
          wasEl.textContent = money(twoWas);
          wasEl.hidden = false;
        } else if (cur.compare_at_price && cur.compare_at_price > unit) {
          wasEl.textContent = money(cur.compare_at_price);
          wasEl.hidden = false;
        } else {
          wasEl.hidden = true;
        }
      }

      if (atc) atc.disabled = !cur.available;
      if (atcLabel) atcLabel.textContent = cur.available ? 'Add to cart' : 'Sold out';
    }

    setBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        sets = parseInt(b.getAttribute('data-sets'), 10) || 1;
        setBtns.forEach(function (x) {
          var on = x === b;
          x.classList.toggle('is-sel', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        render();
      });
    });
    selects.forEach(function (s) { s.addEventListener('change', render); });
    render();
  }

  /* ---------------- gallery ---------------- */
  function initGallery() {
    var main = root.querySelector('[data-rsg-gal-main]');
    var thumbs = root.querySelector('[data-rsg-gal-thumbs]');
    if (!main) return;
    var imgs = Array.prototype.slice.call(main.querySelectorAll('img'));
    function show(i) {
      imgs.forEach(function (m) { m.classList.toggle('is-on', +m.getAttribute('data-i') === i); });
      if (thumbs) thumbs.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-on', +b.getAttribute('data-i') === i);
      });
    }
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () { show(+b.getAttribute('data-i')); });
    });
  }

  /* ---------------- zoom lightbox ---------------- */
  function initLightbox() {
    var main = root.querySelector('[data-rsg-gal-main]');
    var lbx = root.querySelector('[data-rsg-lbx]');
    if (!main || !lbx) return;
    var img = lbx.querySelector('[data-rsg-lbx-img]');
    var closeBtn = lbx.querySelector('[data-rsg-lbx-close]');

    function currentFull() {
      var on = main.querySelector('img.is-on') || main.querySelector('img');
      return on ? (on.getAttribute('data-full') || on.getAttribute('src')) : '';
    }
    function open() {
      var src = currentFull();
      if (!src) return;
      img.src = src;
      img.classList.remove('is-zoomed');
      lbx.hidden = false;
      requestAnimationFrame(function () { lbx.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
    }
    function shut() {
      lbx.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { lbx.hidden = true; img.src = ''; }, 250);
    }

    main.addEventListener('click', open);
    main.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });
    if (closeBtn) closeBtn.addEventListener('click', shut);
    lbx.addEventListener('click', function (e) {
      if (e.target === lbx || (e.target.classList && e.target.classList.contains('rsg-lbx__stage'))) shut();
    });
    img.addEventListener('click', function (e) {
      e.stopPropagation();
      img.classList.toggle('is-zoomed');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lbx.hidden) shut();
    });
  }

  function boot() {
    initBuy();
    initGallery();
    initLightbox();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
